import { defineStore } from 'pinia'
import { IStore } from '../core/interface/IStore'

export default defineStore('systemConsoleStoreV1', {
  state: (): IStore => {
    return {
      records: [],
      opened: false,
    }
  },
})
